var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition-group',{staticClass:"notifications",attrs:{"name":"notifications","tag":"div"}},_vm._l((_vm.notifications),function(notification){return _c('notification',{key:notification.id,attrs:{"id":notification.id,"type":notification.type,"delay":notification.delay,"message":notification.message}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }